import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { apiFetch } from './api';

function ContattiPolizze({ onSelectionChange = () => {} }) {
  // Stati per i dati
  const [contatti, setContatti] = useState([]);
  const [filteredContatti, setFilteredContatti] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  // 🔧 NUOVI STATI PER DATE
  const [dataInizio, setDataInizio] = useState('');
  const [dataFine, setDataFine] = useState('');
  
  // 🔧 FILTRO POLIZZE NUOVE - AGGIUNTO
  const [mostraPolizzeNuove, setMostraPolizzeNuove] = useState(false);
  
  // Stati per i filtri
  const [searchCodiceTessera, setSearchCodiceTessera] = useState('');
  const [searchCognomeNome, setSearchCognomeNome] = useState('');
  const [searchNote, setSearchNote] = useState('');
  const [searchTipoAdesione, setSearchTipoAdesione] = useState('');
  
  // 🔧 STATI PER ORDINAMENTO - AGGIUNTI
  const [sortField, setSortField] = useState('cognomeNome'); // Default: Nome ASC
  const [sortDirection, setSortDirection] = useState('asc');
  
  // Stati per la selezione
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [processingSelection, setProcessingSelection] = useState(false);

  // 🔧 INIZIALIZZAZIONE DATE DEFAULT (giorno corrente)
  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    // Formato YYYY-MM-DD per input date
    const todayString = today.toISOString().split('T')[0];
    const tomorrowString = tomorrow.toISOString().split('T')[0];
    
    setDataInizio(todayString);
    setDataFine(tomorrowString);
    
    console.log('📅 Date inizializzate:', { dataInizio: todayString, dataFine: tomorrowString });
  }, []);

  // Placeholders MEMOIZZATI - FISSI per Polizze
  const placeholders = useMemo(() => [
    '{CODICE_TESSERA}',
    '{COGNOME_NOME}',
    '{INDIRIZZO}',
    '{COMUNE}',
    '{CAP}',
    '{PROVINCIA}',
    '{DATA_INIZIO}',
    '{DATA_FINE}',
    '{DESTINATARI}',
    '{IMPORTO}',
    '{NOTE}',
    '{TIPO_ADESIONE}',
    '{DATA_ODIERNA}',
    '{IMMAGINE_INTESTAZIONE}',
    '{IMMAGINE_FONDO}',
    '{FIRMA_ANUTEL}'
  ], []);

  // Funzione di validazione email semplice
  const isValidEmail = useCallback((email) => {
    return email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }, []);

  // 🔧 FUNZIONE ORDINAMENTO - AGGIUNTA
  const handleSort = useCallback((field) => {
    setSortField(prevField => {
      setSortDirection(prevDirection => {
        if (prevField === field) {
          return prevDirection === 'asc' ? 'desc' : 'asc';
        } else {
          return 'asc';
        }
      });
      return field;
    });
  }, []);

  // 🔧 FUNZIONE ICONE ORDINAMENTO - AGGIUNTA
  const getSortIcon = (field) => {
    if (sortField !== field) {
      return <i className="fas fa-sort text-muted ms-1"></i>;
    }
    return sortDirection === 'asc' ? 
      <i className="fas fa-sort-up text-primary ms-1"></i> : 
      <i className="fas fa-sort-down text-primary ms-1"></i>;
  };

  // 🔧 CARICAMENTO DATI - MODIFICATO PER POST CON DATE
  const loadContatti = useCallback(async (startDate, endDate) => {
    if (!startDate || !endDate) {
      console.warn('⚠️ Date non valide per il caricamento');
      return;
    }

    setLoading(true);
    setError('');
    setContatti([]);
    setFilteredContatti([]);
    setSelectedRows([]);
    
    try {
      console.log('🔄 Caricamento contatti polizze...', { mostraPolizzeNuove });
      
      // 🔧 CREAZIONE PAYLOAD CON DATE IN FORMATO ISO
      const startDateTime = new Date(startDate + 'T00:00:00.000Z');
      const endDateTime = new Date(endDate + 'T23:59:59.999Z');
      
      const payload = {
        dataInizio: startDateTime.toISOString(),
        dataFine: endDateTime.toISOString(),
        // 🔧 AGGIUNTO: Se "Nuovi" è spuntato, aggiungi il parametro NV=1 per il backend
        soloNuove: mostraPolizzeNuove
      };
      
      console.log('📤 Payload invio:', payload);
      
      // 🔧 RICHIESTA POST INVECE DI GET
      const response = await apiFetch('/api/Contact/polizze', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('📊 Dati polizze ricevuti:', data);
        
        // Trasforma i dati in formato compatibile con il sistema
        const contattiConId = (data || []).map((item, index) => {
          // Gestione email dal campo DESTINATARI
          const emailArray = item.DESTINATARI ? 
            item.DESTINATARI.split(';').map(e => e.trim()).filter(e => isValidEmail(e)) : 
            [];

          return {
            id: `polizza_${index}_${Date.now()}`, // ID univoco
            key: `polizza_${item.CODICE_TESSERA}_${index}_${Date.now()}`,
            
            // 🔧 CORREZIONE: Campi originali con nomi CORRETTI dal JSON
            codiceTessera: item.CODICE_TESSERA || '',
            cognomeNome: item.COGNOME_NOME || '',
            indirizzo: item.INDIRIZZO || '',
            comune: item.COMUNE || '',
            cap: item.CAP || '',
            provincia: item.SIGLAPROV || '', // 🔧 Era item.provincia, ora SIGLAPROV
            dataInizio: item.DATA_INIZIO_C || '', // 🔧 Era item.data_Inizio, ora DATA_INIZIO_C
            dataFine: item.DATA_FINE_C || '', // 🔧 Era item.data_Fine, ora DATA_FINE_C
            destinatari: item.DESTINATARI || '', // 🔧 Era item.destinatari, ora DESTINATARI
            importo: item.IMPORTO || '',
            note: item.NOTE || '',
            tipoAdesione: item.TIPO_ADESIONE || '',
            
            // Campi per compatibilità con sistema email
            email: emailArray.length > 0 ? emailArray[0] : '', // Prima email come principale
            emailOrd: emailArray, // Tutte le email come ordinarie
            emailPec: [], // Nessuna PEC specifica nelle polizze
            
            // Compatibilità nomi alternativi
            ragioneSociale: item.COGNOME_NOME || '',
            nome: item.COGNOME_NOME || '',
            
            // 🔧 METADATI - AGGIUNTO TipoAllegato="polizza" per allegati
            hasTessera: false,
            fileUrl: '',
            TipoAllegato: 'polizza' // 🔧 NUOVO: Indica che sono allegati documenti polizza
          };
        });
        
        // 🔧 FILTRO: Mantieni solo le polizze il cui tipo contiene "POLIZZA TIPO" (case insensitive)
        const contattiFilteredByType = contattiConId.filter(c => {
          const tipo = c.tipoAdesione || '';
          const matches = tipo.toUpperCase().includes('POLIZZA TIPO');
          if (!matches) {
            console.log(`[FILTRO TIPO] Scartato: ${c.codiceTessera} - Tipo: "${tipo}"`);
          }
          return matches;
        });
        
        console.log(`[FILTRO TIPO] Filtrate ${contattiConId.length} -> ${contattiFilteredByType.length} polizze (con tipo contenente "POLIZZA TIPO")`);
        
        setContatti(contattiFilteredByType);
        setFilteredContatti(contattiFilteredByType);
        
        console.log(`✅ Caricati ${contattiConId.length} contatti polizze per periodo ${startDate} - ${endDate}`);
      } else {
        const errorText = await response.text();
        throw new Error(`Errore ${response.status}: ${errorText}`);
      }
    } catch (err) {
      console.error('❌ Errore caricamento contatti polizze:', err);
      setError(`Errore nel caricamento: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }, [isValidEmail, mostraPolizzeNuove]); // 🔧 AGGIUNTA DIPENDENZA: mostraPolizzeNuove

  // 🔧 CARICAMENTO AUTOMATICO QUANDO LE DATE SONO DISPONIBILI
  useEffect(() => {
    if (dataInizio && dataFine) {
      loadContatti(dataInizio, dataFine);
    }
  }, []); // Solo al mount, dopo userà il button

  // 🔧 APPLICA FILTRI E ORDINAMENTO - MODIFICATO
  const applyFilters = useCallback(() => {
    setProcessingSelection(true);
    
    setTimeout(() => {
      let filtered = [...contatti];
      
      // ✅ FILTRO RIMOSSO: Il backend filtra già quando mostraPolizzeNuove=true con &NV=1
      // Non serve filtrare lato client; i dati arrivano già filtrati dall'API
      
      // FILTRI ESISTENTI
      if (searchCodiceTessera.trim()) {
        filtered = filtered.filter(c => 
          c.codiceTessera && c.codiceTessera.toLowerCase().includes(searchCodiceTessera.toLowerCase())
        );
      }
      
      if (searchCognomeNome.trim()) {
        filtered = filtered.filter(c => 
          c.cognomeNome && c.cognomeNome.toLowerCase().includes(searchCognomeNome.toLowerCase())
        );
      }
      
      if (searchNote.trim()) {
        filtered = filtered.filter(c => 
          c.note && c.note.toLowerCase().includes(searchNote.toLowerCase())
        );
      }
      
      if (searchTipoAdesione.trim()) {
        filtered = filtered.filter(c => 
          c.tipoAdesione && c.tipoAdesione.toLowerCase().includes(searchTipoAdesione.toLowerCase())
        );
      }
      
      // 🔧 ORDINAMENTO - AGGIUNTO
      if (sortField) {
        filtered.sort((a, b) => {
          let valueA = a[sortField];
          let valueB = b[sortField];
          
          // Gestione valori nulli
          if (valueA == null) valueA = '';
          if (valueB == null) valueB = '';
          
          // 🔧 ORDINAMENTO SPECIFICO PER TIPO CAMPO
          if (sortField === 'dataInizio' || sortField === 'dataFine') {
            // Ordinamento cronologico per date
            valueA = new Date(valueA).getTime() || 0;
            valueB = new Date(valueB).getTime() || 0;
          } else if (sortField === 'importo') {
            // Ordinamento numerico per importo (rimuovi simboli e converti)
            const cleanA = String(valueA).replace(/[^\d,.-]/g, '').replace(',', '.');
            const cleanB = String(valueB).replace(/[^\d,.-]/g, '').replace(',', '.');
            valueA = parseFloat(cleanA) || 0;
            valueB = parseFloat(cleanB) || 0;
          } else {
            // Ordinamento alfabetico standard
            valueA = String(valueA).toLowerCase();
            valueB = String(valueB).toLowerCase();
          }
          
          // Confronto finale
          if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1;
          if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1;
          return 0;
        });
      }
      
      setFilteredContatti(filtered);
      
      // Reset selezioni se i dati filtrati cambiano
      setSelectedRows([]);
      setSelectAll(false);
      setProcessingSelection(false);
    }, 0);
  }, [contatti, searchCodiceTessera, searchCognomeNome, searchNote, searchTipoAdesione, sortField, sortDirection, mostraPolizzeNuove]); // 🔧 Aggiunte dipendenze ordinamento e filtro nuove

  // Applica filtri quando cambiano
  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  // Gestione selezione - CALLBACK MEMOIZZATI
  const handleRowSelection = useCallback((contatto, isSelected) => {
    setSelectedRows(prev => {
      let newSelected;
      if (isSelected) {
        newSelected = [...prev, contatto];
      } else {
        newSelected = prev.filter(r => r.id !== contatto.id);
      }
      return newSelected;
    });
  }, []);

  const handleSelectAll = useCallback(() => {
    setProcessingSelection(true);
    
    setTimeout(() => {
      setSelectAll(prev => {
        const newSelectAll = !prev;
        if (newSelectAll) {
          setSelectedRows([...filteredContatti]);
        } else {
          setSelectedRows([]);
        }
        setProcessingSelection(false);
        return newSelectAll;
      });
    }, 0);
  }, [filteredContatti]);

  // Aggiorna selectAll quando cambiano le selezioni
  useEffect(() => {
    setSelectAll(selectedRows.length === filteredContatti.length && filteredContatti.length > 0);
  }, [selectedRows.length, filteredContatti.length]);

  // COMUNICAZIONE CON PARENT - MEMOIZZATO CON DIPENDENZE STABILI
  useEffect(() => {
    const emailCount = selectedRows.reduce((total, row) => {
      return total + (row.emailOrd?.length || 0) + (row.emailPec?.length || 0);
    }, 0);

    const selectionData = {
      selectedRows: selectedRows,
      destinatariCount: selectedRows.length,
      emailCount,
      placeholders: placeholders
    };

    console.log('📬 ContattiPolizze - Comunicazione con parent:', selectionData);
    onSelectionChange(selectionData);

  }, [selectedRows, placeholders, onSelectionChange]);

  // 🔧 VALIDAZIONE DATE
  const validateDates = () => {
    if (!dataInizio || !dataFine) {
      alert('Seleziona entrambe le date');
      return false;
    }
    
    if (dataInizio > dataFine) {
      alert('La data di inizio deve essere precedente alla data di fine');
      return false;
    }
    
    return true;
  };

  // 🔧 HANDLER AGGIORNAMENTO DATI
  const handleRefreshData = () => {
    if (validateDates()) {
      loadContatti(dataInizio, dataFine);
    }
  };

  // Contatori
  const totalEmails = filteredContatti.reduce((total, row) => 
    total + (row.emailOrd?.length || 0) + (row.emailPec?.length || 0), 0
  );

  return (
    <div className="card border-primary">
      <div className="card-header bg-light">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0 text-primary">
            <i className="fas fa-shield-alt"></i> Contatti Polizze
          </h5>
          <div className="d-flex align-items-center">
            {selectedRows.length > 0 && (
              <span className="badge bg-success me-2">
                <i className="fas fa-check me-1"></i>
                {selectedRows.length} selezionati
              </span>
            )}
            <span className="badge bg-info me-2">
              <i className="fas fa-list me-1"></i>
              {filteredContatti.length} elementi
            </span>
            <span className="badge bg-primary">
              <i className="fas fa-envelope me-1"></i>
              {totalEmails} email
            </span>
          </div>
        </div>
      </div>
      
      <div className="card-body">
        {/* 🔧 SELEZIONE PERIODO - COME PAGAMENTI */}
        <div className="row mb-3">
          {/* 🔧 CHECKBOX POLIZZE NUOVE - POSIZIONATO PRIMA */}
          <div className="col-md-2 d-flex align-items-end">
            <div className="form-check w-100">
              <input 
                className="form-check-input" 
                type="checkbox" 
                id="mostraPolizzeNuove"
                checked={mostraPolizzeNuove}
                onChange={(e) => {
                  console.log('✅ [CHECKBOX] mostraPolizzeNuove changed:', e.target.checked);
                  setMostraPolizzeNuove(e.target.checked);
                }}
                disabled={loading}
              />
              <label className="form-check-label" htmlFor="mostraPolizzeNuove">
                <i className="fas fa-star me-1 text-warning"></i>
                <strong>Nuovi</strong>
              </label>
            </div>
          </div>
          
          <div className="col-md-3">
            <label className="form-label fw-bold text-start w-100">
              <i className="fas fa-calendar me-1 text-muted"></i> Data Inizio:
            </label>
            <input
              type="date"
              className="form-control"
              value={dataInizio}
              onChange={(e) => setDataInizio(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label fw-bold text-start w-100">
              <i className="fas fa-calendar me-1 text-muted"></i> Data Fine:
            </label>
            <input
              type="date"
              className="form-control"
              value={dataFine}
              onChange={(e) => setDataFine(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className="col-md-4 d-flex align-items-end">
            <button 
              className="btn btn-primary"
              onClick={handleRefreshData}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Caricamento...
                </>
              ) : (
                <>
                  <i className="fas fa-sync me-1"></i> Aggiorna Dati
                </>
              )}
            </button>
          </div>
        </div>

        {/* Filtri di ricerca - DIVISI IN 2 RIGHE */}
        <div className="row mb-3">
          <div className="col-md-2"> {/* 🔧 RIDOTTO per codice tessera (6 caratteri max) */}
            <label className="form-label fw-bold text-start w-100">
              <i className="fas fa-id-card me-1 text-muted"></i> Codice Tessera:
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Codice..."
              maxLength="6"
              value={searchCodiceTessera}
              onChange={(e) => setSearchCodiceTessera(e.target.value)}
            />
          </div>
          <div className="col-md-3"> {/* 🔧 AUMENTATO per cognome nome */}
            <label className="form-label fw-bold text-start w-100">
              <i className="fas fa-user me-1 text-muted"></i> Cognome Nome:
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Cognome e nome..."
              value={searchCognomeNome}
              onChange={(e) => setSearchCognomeNome(e.target.value)}
            />
          </div>
          <div className="col-md-2"> {/* 🔧 RIDOTTO per tipo adesione (15 caratteri max) */}
            <label className="form-label fw-bold text-start w-100">
              <i className="fas fa-file-contract me-1 text-muted"></i> Tipo Adesione:
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Tipo..."
              maxLength="15"
              value={searchTipoAdesione}
              onChange={(e) => setSearchTipoAdesione(e.target.value)}
            />
          </div>
          <div className="col-md-5"> {/* 🔧 MANTENUTO per note */}
            <label className="form-label fw-bold text-start w-100">
              <i className="fas fa-sticky-note me-1 text-muted"></i> Note:
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Note..."
              value={searchNote}
              onChange={(e) => setSearchNote(e.target.value)}
            />
          </div>
        </div>
        {/* Stato caricamento/errori */}
        {loading && (
          <div className="text-center py-4">
            <div className="spinner-border text-primary me-2" role="status"></div>
            <span>Caricamento contatti polizze...</span>
          </div>
        )}

        {error && (
          <div className="alert alert-danger">
            <i className="fas fa-exclamation-triangle me-2"></i>
            {error}
          </div>
        )}

        {/* 🔧 TABELLA DATI CON ORDINAMENTO - MODIFICATA */}
        {!loading && !error && (
          <div className="table-responsive position-relative" style={{ maxHeight: 500, overflowY: 'auto' }}>
            {processingSelection && (
              <div className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-white bg-opacity-75" style={{zIndex:10}}>
                <i className="fas fa-spinner fa-spin fa-2x text-primary mb-2"></i>
                <div className="fw-bold">Aggiornamento selezione...</div>
              </div>
            )}
            
            <table className="table table-sm table-hover mb-0">
              <thead className="table-dark sticky-top">
                <tr>
                  <th style={{width: '50px'}}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={selectAll}
                        ref={el => { 
                          if (el) el.indeterminate = selectedRows.length > 0 && selectedRows.length < filteredContatti.length; 
                        }}
                        onChange={handleSelectAll}
                        disabled={filteredContatti.length === 0}
                      />
                    </div>
                  </th>
                  <th style={{cursor: 'pointer'}} onClick={() => handleSort('codiceTessera')}>
                    Tessera {getSortIcon('codiceTessera')}
                  </th>
                  <th style={{cursor: 'pointer'}} onClick={() => handleSort('cognomeNome')}>
                    Nome {getSortIcon('cognomeNome')}
                  </th>
                  <th style={{cursor: 'pointer'}} onClick={() => handleSort('dataInizio')}>
                    Periodo {getSortIcon('dataInizio')}
                  </th>
                  <th style={{cursor: 'pointer'}} onClick={() => handleSort('importo')}>
                    Importo {getSortIcon('importo')}
                  </th>
                  <th style={{cursor: 'pointer'}} onClick={() => handleSort('tipoAdesione')}>
                    Tipo {getSortIcon('tipoAdesione')}
                  </th>
                  <th style={{cursor: 'pointer'}} onClick={() => handleSort('destinatari')}>
                    Email {getSortIcon('destinatari')}
                  </th>
                  <th style={{cursor: 'pointer'}} onClick={() => handleSort('note')}>
                    Note {getSortIcon('note')}
                  </th>
                  <th style={{minWidth: '100px'}}>
                    <i className="fas fa-paperclip text-danger me-1"></i>Allegati
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredContatti.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center py-4 text-muted"> {/* 🔧 AGGIORNATO colSpan da 8 a 9 per la nuova colonna Allegati */}
                      <i className="fas fa-inbox me-2"></i>
                      {loading ? 'Caricamento in corso...' : 'Nessuna polizza trovata per il periodo selezionato'}
                    </td>
                  </tr>
                ) : (
                  filteredContatti.map((contatto) => (
                    <tr key={contatto.id}>
                      <td>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedRows.some(r => r.id === contatto.id)}
                            onChange={(e) => handleRowSelection(contatto, e.target.checked)}
                          />
                        </div>
                      </td>
                      <td>
                        <span className="badge bg-warning text-dark">
                          <i className="fas fa-id-card me-1"></i>
                          {contatto.codiceTessera}
                        </span>
                      </td>
                      <td className="fw-bold" style={{maxWidth: '200px'}}>
                        <div className="text-truncate" title={contatto.cognomeNome}>
                          {contatto.cognomeNome}
                        </div>
                      </td>
                      <td style={{minWidth: '120px'}}>
                        <small className="text-primary">
                          <div><strong>Dal:</strong> {contatto.dataInizio}</div>
                          <div><strong>Al:</strong> {contatto.dataFine}</div>
                        </small>
                      </td>
                      <td>
                        <span className="text-success fw-bold">{contatto.importo}</span>
                      </td>
                      <td style={{minWidth: '140px'}}>
                        <span className="badge bg-secondary text-wrap">
                          {contatto.tipoAdesione}
                        </span>
                      </td>
                      <td style={{minWidth: '200px'}}>
                        {contatto.emailOrd?.length > 0 ? (
                          <div>
                            <span className="badge bg-primary me-1">{contatto.emailOrd.length}</span>
                            <small className="text-truncate d-block" title={contatto.destinatari}>
                              <i className="fas fa-envelope text-primary me-1"></i>
                              {contatto.destinatari}
                            </small>
                          </div>
                        ) : (
                          <span className="text-muted">
                            <i className="fas fa-envelope-slash me-1"></i>
                            Nessuna email
                          </span>
                        )}
                      </td>
                      <td style={{maxWidth: '120px'}}>
                        {contatto.note && contatto.note.trim() ? (
                          <small className="text-truncate d-block" title={contatto.note}>
                            <i className="fas fa-sticky-note text-warning me-1"></i>
                            {contatto.note}
                          </small>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      {/* 🔧 COLONNA ALLEGATI POLIZZA - AGGIUNTA */}
                      <td style={{minWidth: '100px'}}>
                        {contatto.TipoAllegato === 'polizza' ? (
                          <span className="badge bg-danger text-white" title="Documenti polizza allegati">
                            <i className="fas fa-file-pdf me-1"></i>
                            Polizza
                          </span>
                        ) : (
                          <span className="text-muted">
                            <i className="fas fa-ban me-1"></i>
                            Nessuno
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Info selezione */}
        {filteredContatti.length > 0 && (
          <div className="d-flex justify-content-between align-items-center mt-3">
            <small className="text-muted">
              <i className="fas fa-info-circle me-1"></i>
              Visualizzati {filteredContatti.length} di {contatti.length} elementi - Periodo: {dataInizio} / {dataFine}
            </small>
            {selectedRows.length > 0 && (
              <small className="text-success">
                <i className="fas fa-check-circle me-1"></i>
                {selectedRows.length} elementi selezionati - {totalEmails} email da inviare
              </small>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ContattiPolizze;